import React, { Component } from "react";
import { UserData, blankApp } from "../../api";
import Loader from "../loader/loader";
import Header from "../preapps/Header";
import "./create-app-by-link.scss";
import config from "../../config";

export default class CreateAppByLink extends Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
            show_spinner: true,
            error: "",
        };
    }

    componentDidMount() {
        UserData().then((response) => {
            this.setState({ user: response });
        });
        let data = {
            orgSlug: this.props.match.params.org_slug,
            agentUrl: this.props.match.params.agent_url,
            templateId: this.props.match.params.template_id,
            ems_office: this.props.match.params.ems_office,
        };
        blankApp(data)
            .then((res) => {
                if (res.status) {
                    window.location.href = res.redirect_url;
                } else {
                    this.setState({
                        error: res.message,
                        show_spinner: false,
                    });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    render() {
        const { user, show_spinner, error } = this.state;

        return (
            <div className="website-wrapper application-page create-app-by-link">
                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : error ? (
                    <h4 className="error-text">{error}</h4>
                ) : (
                    ""
                )}
            </div>
        );
    }
}
